export enum StoreStatusReason {
  APPROVED = 'approved',
  DENIED = 'denied',
  PENDING_DEBT = 'pending_debt',
}
